import { useQuery } from '@apollo/client';
import { LenderPerformanceReportInput } from '@trnsact/trnsact-shared-types';

import { reportsApi } from '../api';
import { toAsyncResource } from '../lib';
import { ConversionTableSorting } from '../types';
import {
  LenderAverageRateByLenderQueryResponse,
  LenderTotalCostComparisonQueryResponse,
  LenderTermsComparisonTableQueryResponse,
  LenderApprovalTermsSummaryQueryResponse,
  LenderTermDistributionByLenderQueryResponse,
} from '../api/types';

export const useLenderPerformanceApprovalTerms = (
  input: LenderPerformanceReportInput,
  sorting: ConversionTableSorting
) => {
  const summaryResponse = useQuery<LenderApprovalTermsSummaryQueryResponse>(reportsApi.getLenderApprovalTermsSummary, {
    variables: {
      input,
    },
  });

  const comparisonResponse = useQuery<LenderTermsComparisonTableQueryResponse>(
    reportsApi.getLenderTermsComparisonTable,
    {
      variables: {
        input: { ...input, sorting },
      },
    }
  );

  const averageRateResponse = useQuery<LenderAverageRateByLenderQueryResponse>(
    reportsApi.getLenderAverageRateByLender,
    {
      variables: {
        input,
      },
    }
  );

  const termDistributionResponse = useQuery<LenderTermDistributionByLenderQueryResponse>(
    reportsApi.getLenderTermDistributionByLender,
    {
      variables: {
        input,
      },
    }
  );

  const totalCostResponse = useQuery<LenderTotalCostComparisonQueryResponse>(reportsApi.getLenderTotalCostComparison, {
    variables: {
      input,
    },
  });

  return {
    totalCost: toAsyncResource(totalCostResponse, []),
    comparison: toAsyncResource(comparisonResponse, []),
    averageRate: toAsyncResource(averageRateResponse, []),
    summary: toAsyncResource(summaryResponse, null),
    termDistribution: toAsyncResource(termDistributionResponse, []),
    isLoading:
      totalCostResponse.loading ||
      comparisonResponse.loading ||
      averageRateResponse.loading ||
      termDistributionResponse.loading ||
      summaryResponse.loading,
  };
};
